var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.999 0H5.99902C2.68532 0 -0.000976562 2.68629 -0.000976562 6V34C-0.000976562 37.3137 2.68532 40 5.99902 40H33.999C37.3127 40 39.999 37.3137 39.999 34V6C39.999 2.68629 37.3127 0 33.999 0Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18180_90900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3775 14.0684C12.2587 14.0684 9.73047 16.613 9.73047 19.7539C10.0283 27.2972 20.728 27.2936 21.0245 19.7539C21.0245 16.6139 18.4961 14.0684 15.3775 14.0684ZM24.396 14.4017C22.8367 14.4017 21.5725 16.7986 21.5725 19.7539C21.7273 26.8564 27.0652 26.8566 27.2197 19.7539C27.2195 16.7988 25.9553 14.4017 24.396 14.4017ZM28.7605 14.9586C27.456 15.0506 27.4588 24.4625 28.7603 24.5493C30.0643 24.4579 30.062 15.0449 28.7605 14.9586Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18180_90900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 21.06,
    fill: "white",
    transform: "translate(9.20508 9.20703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.af57812109ceb042649341641906d033.svg";
export { ForwardRef as ReactComponent };